import { graphFetch, initialFetch } from '../../src/api/fetchConfig';
import { gql } from '@apollo/client';

const REST_URL = 'http://localhost:8080';

// GraphQL Queries
export const GET_ALL_FILES = gql`
  query GetAllFiles {
    getAllFiles {
      id
      uuid
      upUuid
      name
      extension
      path
      size
      menuId
      flagLocal
      compCd
      thumbnail
      remark
    }
  }
`;

export const FIND_3D_MODEL = gql`
  query Find3DModel {
    find3DModel {
      id
      uuid
      upUuid
      name
      extension
      path
      size
      menuId
      flagLocal
      compCd
      thumbnail
      remark
    }
  }
`;

export const GET_FOLDER_CONTENTS = gql`
  query GetFolderContents($uuid: String, $shared: Boolean) {
    getFolderContents(uuid: $uuid, shared: $shared) {
      id
      compCd
      uuid
      upUuid
      parentName
      name
      extension
      path
      size
      menuId
      thumbnailUrl
      remark
      bookmarkId
      action
      usingDate
      shareId
      createUserName
      createDate
      createUser
      updateDate
      updateUser
    }
  }
`;

export const GET_TRASHCAN = gql`
  query GetTrashcan {
    getTrashcan {
      id
      compCd
      uuid
      upUuid
      parentName
      name
      extension
      path
      size
      menuId
      thumbnailUrl
      remark
      bookmarkId
      action
      usingDate
      shareId
      createUserName
      createDate
      createUser
      updateDate
      updateUser
    }
  }
`;

export const GET_SHARING_CONTENTS = gql`
  query GetSharingContents($uuid: String) {
    getSharingContents(uuid: $uuid) {
      id
      compCd
      uuid
      upUuid
      parentName
      name
      extension
      path
      size
      menuId
      thumbnailUrl
      remark
      bookmarkId
      action
      usingDate
      shareId
      createUserName
      createDate
      createUser
      updateDate
      updateUser
    }
  }
`;

export const GET_FULL_PATH = gql`
  query GetFullPath($req: DriveFullPathRequest!) {
    getFullPath(req: $req) {
      uuid
      name
      extension
    }
  }
`;

export const GET_MENUS_FOR_SELECT = gql`
  query GetMenusForSelect {
    getMenusForSelect {
      menuId
      menuName
    }
  }
`;

export const GET_DRIVE_BOOKMARK = gql`
  query GetDriveBookMark {
    getDriveBookMark {
      id
      compCd
      uuid
      upUuid
      parentName
      name
      extension
      path
      size
      menuId
      thumbnailUrl
      remark
      bookmarkId
      action
      usingDate
      shareId
      createUserName
      createDate
      createUser
      updateDate
      updateUser
    }
  }
`;

export const GET_RECENTLY_DOCS = gql`
  query GetRecentlyDocs {
    getRecentlyDocs {
      id
      compCd
      uuid
      upUuid
      parentName
      name
      extension
      path
      size
      menuId
      thumbnailUrl
      remark
      bookmarkId
      action
      usingDate
      shareId
      createUserName
      createDate
      createUser
      updateDate
      updateUser
    }
  }
`;

export const GET_HISTORICAL_INQUIRY = gql`
  query GetHistoricalInquiry($id: Int!, $type: String!, $shared: Boolean) {
    getHistoricalInquiry(id: $id, type: $type, shared: $shared) {
      id
      action
      targetId
      compCd
      type
      original
      changed
      createDate
      createUser
      updateDate
      updateUser
    }
  }
`;

export const GET_STORAGE_CAPACITY = gql`
  query GetStorageCapacity {
    getStorageCapacity {
      files {
        id
        compCd
        uuid
        upUuid
        parentName
        name
        extension
        path
        size
        menuId
        thumbnailUrl
        remark
        bookmarkId
        action
        usingDate
        shareId
        createUserName
        createDate
        createUser
        updateDate
        updateUser
      }
      meta {
        clientId
        clientName
        usage
      }
      maxStorageGb
    }
  }
`;

export const GET_TOTAL_USAGE = gql`
  query GetTotalUsage {
    getTotalUsage {
      maxUsage
      used
    }
  }
`;

// GraphQL Mutations - File Operations
export const DELETE_FILE = gql`
  mutation DeleteFile($id: Int!) {
    deleteFile(id: $id)
  }
`;

export const REAL_DELETE_FILE = gql`
  mutation RealDeleteFile($uuid: String!) {
    realDeleteFile(uuid: $uuid)
  }
`;

export const REAL_DELETE_SINGLE_FOLDER = gql`
  mutation RealDeleteSingleFolder($uuid: String!) {
    realDeleteSingleFolder(uuid: $uuid) {
      name
      extension
      flagSuccess
    }
  }
`;

export const SOFT_DELETE_FILE = gql`
  mutation SoftDeleteFile($uuid: String!) {
    softDeleteFile(uuid: $uuid) {
      id
      uuid
      upUuid
      name
      extension
      path
      size
      menuId
      flagLocal
      compCd
      thumbnail
      remark
    }
  }
`;

export const RENAME_FILE = gql`
  mutation RenameFile($uuid: String!, $newName: String!) {
    renameFile(uuid: $uuid, newName: $newName) {
      id
      uuid
      upUuid
      name
      extension
      path
      size
      menuId
      flagLocal
      compCd
      thumbnail
      remark
    }
  }
`;

export const CHANGE_FILE_MENU_ID = gql`
  mutation ChangeFileMenuId($uuid: String!, $menuId: String!) {
    changeFileMenuId(uuid: $uuid, menuId: $menuId) {
      id
      uuid
      upUuid
      name
      extension
      path
      size
      menuId
      flagLocal
      compCd
      thumbnail
      remark
    }
  }
`;

export const COPY_FILE = gql`
  mutation CopyFile($uuid: String!) {
    copyFile(uuid: $uuid) {
      id
      uuid
      upUuid
      name
      extension
      path
      size
      menuId
      flagLocal
      compCd
      thumbnail
      remark
    }
  }
`;

export const RESTORE_FILE = gql`
  mutation RestoreFile($uuid: String!, $upUuid: String!) {
    restoreFile(uuid: $uuid, upUuid: $upUuid) {
      id
      uuid
      upUuid
      name
      extension
      path
      size
      menuId
      flagLocal
      compCd
      thumbnail
      remark
    }
  }
`;

export const MOVE_FILE = gql`
  mutation MoveFile($req: FolderMoveRequest!) {
    moveFile(req: $req) {
      id
      uuid
      upUuid
      name
      extension
      path
      size
      menuId
      flagLocal
      compCd
      thumbnail
      remark
    }
  }
`;

// GraphQL Mutations - Folder Operations
export const CREATE_FOLDER = gql`
  mutation CreateFolder($req: InsertFolderRequest!) {
    createFolder(req: $req) {
      id
      uuid
      upUuid
      name
      compCd
    }
  }
`;

export const RENAME_FOLDER = gql`
  mutation RenameFolder($req: FolderRenameRequest!) {
    renameFolder(req: $req) {
      id
      uuid
      upUuid
      name
      compCd
    }
  }
`;


export const MOVE_FOLDER = gql`
  mutation MoveFolder($req: FolderMoveRequest!) {
    moveFolder(req: $req) {
      id
      uuid
      upUuid
      name
      compCd
    }
  }
`;

export const SOFT_DELETE_FOLDER = gql`
  mutation SoftDeleteFolder($uuid: String!) {
    softDeleteFolder(uuid: $uuid) {
      id
      uuid
      upUuid
      name
      compCd
    }
  }
`;

export const RESTORE_FOLDER = gql`
  mutation RestoreFolder($uuid: String!) {
    restoreFolder(uuid: $uuid) {
      id
      uuid
      upUuid
      name
      compCd
    }
  }
`;

export const MOVE_SELECTED = gql`
  mutation MoveSelected($targetFolderUuid: String!, $fileUuids: [String!]!, $folderUuids: [String!]!) {
    moveSelected(targetFolderUuid: $targetFolderUuid, fileUuids: $fileUuids, folderUuids: $folderUuids)
  }
`;

export const EMPTY_TRASH_PROCESS = gql`
  mutation EmptyTrashProcess($req: EmptyTrashRequest!) {
    emptyTrashProcess(req: $req) {
      name
      extension
      flagSuccess
    }
  }
`;

export const RESTORE_SELECTED = gql`
  mutation RestoreSelected($fileUuids: [String], $folderUuids: [String]) {
    restoreSelected(fileUuids: $fileUuids, folderUuids: $folderUuids)
  }
`;

export const TRASH_SELECTED = gql`
  mutation TrashSelected($fileUuids: [String], $folderUuids: [String]) {
    trashSelected(fileUuids: $fileUuids, folderUuids: $folderUuids)
  }
`;

export const COPY_SELECTED = gql`
  mutation CopySelected($uuids: [String]!) {
    copySelected(uuids: $uuids)
  }
`;

export const CREATE_SHARE = gql`
  mutation CreateShare($req: CreateDriveShareReq!) {
    createShare(req: $req) {
      id
      uuid
      type
      minReadLevel
      minWriteLevel
      minCopyLevel
      createDate
      createUser
      updateDate
      updateUser
    }
  }
`;

export const RENAME_SHARE = gql`
  mutation RenameShare($shareId: Int!, $driveType: String!, $changed: String!) {
    renameShare(shareId: $shareId, driveType: $driveType, changed: $changed) {
      compCd
      uuid
      upUuid
      parentName
      name
      extension
      path
      size
      menuId
      thumbnailUrl
      remark

      createUserName
      createDate
      createUser
      updateDate
      updateUser
    }
  }
`;

export const COPY_SHARE_FILE_TO_MY_DRIVE = gql`
  mutation CopyShareFileToMyDrive($shareId: Int!) {
    copyShareFileToMyDrive(shareId: $shareId) {
      id
      uuid
      upUuid
      name
      extension
      path
      size
      menuId
      flagLocal
      compCd
      thumbnail
      remark
    }
  }
`;

export const DELETE_SHARE = gql`
  mutation DeleteShare($shareId: Int!, $driveType: String!) {
    deleteShare(shareId: $shareId, driveType: $driveType) {
      id
      uuid
      type
      minReadLevel
      minWriteLevel
      minCopyLevel
      createDate
      createUser
      updateDate
      updateUser
    }
  }
`;

export const SET_PERMISSION = gql`
  mutation SetPermission($req: SetPermissionReq!) {
    setPermission(req: $req) {
      id
      uuid
      type
      minReadLevel
      minWriteLevel
      minCopyLevel
      createDate
      createUser
      updateDate
      updateUser
    }
  }
`;

export const GENERATE_BOOKMARK = gql`
  mutation GenerateBookMark($req: DriveBookMarkReq!) {
    generateBookMark(req: $req) {
      id
      uuid
      shareId
      flagFile
      flagShared
      createDate
      createUser
      updateDate
      updateUser
    }
  }
`;

export const DELETE_DRIVE_BOOKMARK = gql`
  mutation DeleteDriveBookMark($id: Int!) {
    deleteDriveBookMark(id: $id)
  }
`;

// Helper functions for GraphQL operations
export const getAllFiles = async (executeQuery) => {
  try {
    const result = await executeQuery(GET_ALL_FILES);
    return result?.data?.getAllFiles || [];
  } catch (error) {
    console.error('Error fetching all files:', error);
    throw error;
  }
};

export const getFolderContents = async (executeQuery, uuid = null, shared = null) => {
  try {
    const result = await executeQuery(GET_FOLDER_CONTENTS, { uuid, shared });
    return result?.data?.getFolderContents || [];
  } catch (error) {
    console.error('Error fetching folder contents:', error);
    throw error;
  }
};

export const getTrashcan = async (executeQuery) => {
  try {
    const result = await executeQuery(GET_TRASHCAN);
    return result?.data?.getTrashcan || [];
  } catch (error) {
    console.error('Error fetching trashcan:', error);
    throw error;
  }
};

export const find3DModel = async (executeQuery) => {
  try {
    const result = await executeQuery(FIND_3D_MODEL);
    return result?.data?.find3DModel || null;
  } catch (error) {
    console.error('Error fetching 3D model:', error);
    throw error;
  }
};

export const getFullPath = async (executeQuery, uuid, extension = null) => {
  try {
    const req = { uuid, extension };
    const result = await executeQuery(GET_FULL_PATH, { req });
    return result?.data?.getFullPath || [];
  } catch (error) {
    console.error('Error fetching full path:', error);
    throw error;
  }
};

export const getMenusForSelect = async (executeQuery) => {
  try {
    const result = await executeQuery(GET_MENUS_FOR_SELECT);
    return result?.data?.getMenusForSelect || [];
  } catch (error) {
    console.error('Error fetching menus for select:', error);
    throw error;
  }
};

export const deleteFile = async (executeMutation, id) => {
  try {
    const result = await executeMutation(DELETE_FILE, { id });
    return result?.data?.deleteFile;
  } catch (error) {
    console.error('Error deleting file:', error);
    throw error;
  }
};

export const realDeleteFile = async (executeMutation, uuid) => {
  try {
    const result = await executeMutation(REAL_DELETE_FILE, { uuid });
    return result?.data?.realDeleteFile;
  } catch (error) {
    console.error('Error permanently deleting file:', error);
    throw error;
  }
};

export const realDeleteSingleFolder = async (executeMutation, uuid) => {
  try {
    const result = await executeMutation(REAL_DELETE_SINGLE_FOLDER, { uuid });
    return result?.data?.realDeleteSingleFolder;
  } catch (error) {
    console.error('Error permanently deleting folder:', error);
    throw error;
  }
};

export const softDeleteFile = async (executeMutation, uuid) => {
  try {
    const result = await executeMutation(SOFT_DELETE_FILE, { uuid });
    return result?.data?.softDeleteFile;
  } catch (error) {
    console.error('Error soft deleting file:', error);
    throw error;
  }
};

export const renameFile = async (executeMutation, uuid, newName) => {
  try {
    const result = await executeMutation(RENAME_FILE, { uuid, newName });
    return result?.data?.renameFile;
  } catch (error) {
    console.error('Error renaming file:', error);
    throw error;
  }
};

export const copyFile = async (executeMutation, uuid) => {
  try {
    const result = await executeMutation(COPY_FILE, { uuid });
    return result?.data?.copyFile;
  } catch (error) {
    console.error('Error copying file:', error);
    throw error;
  }
};

export const restoreFile = async (executeMutation, uuid, upUuid) => {
  try {
    const result = await executeMutation(RESTORE_FILE, { uuid, upUuid });
    return result?.data?.restoreFile;
  } catch (error) {
    console.error('Error restoring file:', error);
    throw error;
  }
};

export const moveFile = async (executeMutation, req) => {
  try {
    const result = await executeMutation(MOVE_FILE, { req });
    return result?.data?.moveFile;
  } catch (error) {
    console.error('Error moving folder:', error);
    throw error;
  }
};

export const createFolder = async (executeMutation, req) => {
  try {
    const result = await executeMutation(CREATE_FOLDER, { req });
    return result?.data?.createFolder;
  } catch (error) {
    console.error('Error creating folder:', error);
    throw error;
  }
};

// Backward compatibility alias
export const generateFolder = createFolder;

export const renameFolder = async (executeMutation, req) => {
  try {
    const result = await executeMutation(RENAME_FOLDER, { req });
    return result?.data?.renameFolder;
  } catch (error) {
    console.error('Error renaming folder:', error);
    throw error;
  }
};

export const moveFolder = async (executeMutation, req) => {
  try {
    const result = await executeMutation(MOVE_FOLDER, { req });
    return result?.data?.moveFolder;
  } catch (error) {
    console.error('Error moving folder:', error);
    throw error;
  }
};

export const softDeleteFolder = async (executeMutation, uuid) => {
  try {
    const result = await executeMutation(SOFT_DELETE_FOLDER, { uuid });
    return result?.data?.softDeleteFolder;
  } catch (error) {
    console.error('Error soft deleting folder:', error);
    throw error;
  }
};

export const restoreFolder = async (executeMutation, uuid) => {
  try {
    const result = await executeMutation(RESTORE_FOLDER, { uuid });
    return result?.data?.restoreFolder;
  } catch (error) {
    console.error('Error restoring folder:', error);
    throw error;
  }
};

export const moveSelected = async (executeMutation, targetFolderUuid, fileUuids, folderUuids) => {
  try {
    const result = await executeMutation(MOVE_SELECTED, {
      targetFolderUuid,
      fileUuids: fileUuids || [],
      folderUuids: folderUuids || []
    });
    return result?.data?.moveSelected;
  } catch (error) {
    console.error('Error moving selected items:', error);
    throw error;
  }
};

export const emptyTrashProcess = async (executeMutation, fileUuids, folderUuids) => {
  try {
    const req = {
      fileUuids: fileUuids || [],
      folderUuids: folderUuids || []
    };
    const result = await executeMutation(EMPTY_TRASH_PROCESS, { req });
    return result?.data?.emptyTrashProcess || [];
  } catch (error) {
    console.error('Error emptying trash:', error);
    throw error;
  }
};

export const restoreSelected = async (executeMutation, fileUuids, folderUuids) => {
  try {
    const result = await executeMutation(RESTORE_SELECTED, {
      fileUuids: fileUuids || [],
      folderUuids: folderUuids || []
    });
    return result?.data?.restoreSelected;
  } catch (error) {
    console.error('Error restoring selected items:', error);
    throw error;
  }
};

export const trashSelected = async (executeMutation, fileUuids, folderUuids) => {
  try {
    const result = await executeMutation(TRASH_SELECTED, {
      fileUuids: fileUuids || [],
      folderUuids: folderUuids || []
    });
    return result?.data?.trashSelected;
  } catch (error) {
    console.error('Error moving selected items to trash:', error);
    throw error;
  }
};

// 공유 문서함 관련 서비스 함수들
export const getSharingContents = async (executeQuery, uuid) => {
  try {
    const result = await executeQuery(GET_SHARING_CONTENTS, { uuid });
    return result?.data?.getSharingContents || [];
  } catch (error) {
    console.error('Error getting sharing contents:', error);
    throw error;
  }
};

export const createShare = async (executeMutation, req) => {
  try {
    const result = await executeMutation(CREATE_SHARE, { req });
    return result?.data?.createShare;
  } catch (error) {
    console.error('Error creating share:', error);
    throw error;
  }
};

export const renameShare = async (executeMutation, shareId, driveType, changed) => {
  try {
    const result = await executeMutation(RENAME_SHARE, { shareId, driveType, changed });
    return result?.data?.renameShare;
  } catch (error) {
    console.error('Error renaming share:', error);
    throw error;
  }
};

export const copyShareFileToMyDrive = async (executeMutation, shareId) => {
  try {
    const result = await executeMutation(COPY_SHARE_FILE_TO_MY_DRIVE, { shareId });
    return result?.data?.copyShareFileToMyDrive;
  } catch (error) {
    console.error('Error copying share file to my drive:', error);
    throw error;
  }
};

export const deleteShare = async (executeMutation, shareId, driveType) => {
  try {
    const result = await executeMutation(DELETE_SHARE, { shareId, driveType });
    return result?.data?.deleteShare;
  } catch (error) {
    console.error('Error deleting share:', error);
    throw error;
  }
};

export const setPermission = async (executeMutation, req) => {
  try {
    const result = await executeMutation(SET_PERMISSION, { req });
    return result?.data?.setPermission;
  } catch (error) {
    console.error('Error setting permission:', error);
    throw error;
  }
};

// 즐겨찾기 관련 함수들
export const getDriveBookMark = async (executeQuery) => {
  try {
    const result = await executeQuery(GET_DRIVE_BOOKMARK);
    return result?.data?.getDriveBookMark || [];
  } catch (error) {
    console.error('Error getting drive bookmarks:', error);
    throw error;
  }
};

export const generateBookMark = async (executeMutation, req) => {
  try {
    const result = await executeMutation(GENERATE_BOOKMARK, { req });
    return result?.data?.generateBookMark;
  } catch (error) {
    console.error('Error generating bookmark:', error);
    throw error;
  }
};

export const deleteDriveBookMark = async (executeMutation, id) => {
  try {
    const result = await executeMutation(DELETE_DRIVE_BOOKMARK, { id });
    return result?.data?.deleteDriveBookMark;
  } catch (error) {
    console.error('Error deleting bookmark:', error);
    throw error;
  }
};

// 파일 업로드 - 관리자용 API (복수 파일, FileUploadReq 구조 사용)
export const uploadFileAdmin = async (menuId, upUuid, flagLocal, files, indoor) => {
  const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  const relativeUrl = '/api/drive/add/dev'
  const fullUrl = isLocalhost ? REST_URL + relativeUrl : relativeUrl;

  const formData = new FormData();
  formData.append('menuId', menuId);
  formData.append('upUuid', upUuid || ''); // 빈 문자열은 루트 폴더
  formData.append('flagLocal', flagLocal || false);
  formData.append('indoor', indoor || false);
  
  // 복수 파일을 files 필드로 추가
  if (Array.isArray(files)) {
    files.forEach(file => {
      formData.append('files', file);
    });
  } else {
    // 단일 파일인 경우 배열로 변환하여 처리
    formData.append('files', files);
  }

  const response = await fetch(fullUrl, {
    method: 'POST',
    body: formData,
    credentials: 'include'
  });

  // 에러 응답 처리
  if (!response.ok) {
    const errorText = await response.text().catch(() => '업로드 실패');
    const error = new Error(errorText || `업로드 실패 (${response.status})`);
    error.response = response;
    throw error;
  }

  // String 응답 반환
  const result = await response.text();
  return result;
};


// 파일 업로드 - 일반 사용자용 API
export const uploadFiles = async (parentId, files) => {
  const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  const relativeUrl = '/api/drive/add' // 일반 사용자용 엔드포인트
  const fullUrl = isLocalhost ? REST_URL + relativeUrl : relativeUrl;

  const formData = new FormData();
  formData.append('parentId', parentId || ''); // 빈 문자열은 루트 폴더

  // 파일들을 FormData에 추가
  files.forEach(file => {
    formData.append('files', file);
  });

  const response = await fetch(fullUrl, {
    method: 'POST',
    body: formData,
    credentials: 'include'
  });

  // 에러 응답 처리
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const error = new Error(errorData.message || `업로드 실패 (${response.status})`);
    error.response = response;
    error.data = errorData;
    throw error;
  }

  // FileUploadRes[] 형태의 응답 반환
  const result = await response.json();
  return result;
};

// 파일 다운로드
export const downloadFile = async (id) => {
  const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  const relativeUrl = '/api/drive/download'
  const fullUrl = isLocalhost ? REST_URL + relativeUrl : relativeUrl;

  const response = await fetch(fullUrl + `?uuid=${id}`, {
    method: 'GET',
    credentials: 'include', // 🔥 쿠키 포함
  });

  // 에러 응답 처리
  if (!response.ok) {
    const errorText = await response.text().catch(() => '다운로드 실패');
    const error = new Error(errorText || `다운로드 실패 (${response.status})`);
    error.response = response;
    throw error;
  }

  return response; // ✅ Response 객체 반환으로 변경
};

// 공유 파일 다운로드
export const downloadShare = async (shareId) => {
  const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  const relativeUrl = '/api/drive/download/share'
  const fullUrl = isLocalhost ? REST_URL + relativeUrl : relativeUrl;

  const response = await fetch(fullUrl + `?shareId=${shareId}`, {
    method: 'GET',
    credentials: 'include', // 🔥 쿠키 포함
  });

  // 에러 응답 처리
  if (!response.ok) {
    const errorText = await response.text().catch(() => '공유 파일 다운로드 실패');
    const error = new Error(errorText || `공유 파일 다운로드 실패 (${response.status})`);
    error.response = response;
    throw error;
  }

  return response; // ✅ Response 객체 반환으로 변경
};

// 최근 문서함 조회
export const getRecentlyDocs = async (executeQuery) => {
  try {
    const result = await executeQuery(GET_RECENTLY_DOCS);
    return result?.data?.getRecentlyDocs || [];
  } catch (error) {
    console.error('Error fetching recently docs:', error);
    throw error;
  }
};

// 파일/폴더 활동 내역 조회
export const getHistoricalInquiry = async (executeQuery, id, type, shared = null) => {
  try {
    const result = await executeQuery(GET_HISTORICAL_INQUIRY, { id, type, shared });
    return result?.data?.getHistoricalInquiry || [];
  } catch (error) {
    console.error('Error fetching historical inquiry:', error);
    throw error;
  }
};

// 저장용량 조회
export const getStorageCapacity = async (executeQuery) => {
  try {
    const result = await executeQuery(GET_STORAGE_CAPACITY);
    return result?.data?.getStorageCapacity || { files: [], meta: [], maxStorageGb: 0 };
  } catch (error) {
    console.error('Error fetching storage capacity:', error);
    throw error;
  }
};

// 전체 사용량 조회
export const getTotalUsage = async (executeQuery) => {
  try {
    const result = await executeQuery(GET_TOTAL_USAGE);
    return result?.data?.getTotalUsage || { maxUsage: 0, used: 0 };
  } catch (error) {
    console.error('Error fetching total usage:', error);
    throw error;
  }
};

// 선택된 파일들 복사
export const copySelected = async (executeQuery, uuids) => {
  try {
    const result = await executeQuery(COPY_SELECTED, { uuids });
    return result?.data?.copySelected || false;
  } catch (error) {
    console.error('Error copying selected files:', error);
    throw error;
  }
};